// extracted by mini-css-extract-plugin
export var productOverview = "ProductOverview-module--productOverview--7LLet";
export var inner = "ProductOverview-module--inner---Rwzq";